import Vue from 'vue'

const bus = new Vue()

export function openLogin(redirectPath) {
  const redirect = typeof redirectPath === 'string' && redirectPath.startsWith('/')
    ? redirectPath
    : '/workbench'
  bus.$emit('portal-login-open', { redirect })
}

export function closeLogin() {
  bus.$emit('portal-login-close')
}

export function onLoginOpen(handler) {
  bus.$on('portal-login-open', handler)
}

export function offLoginOpen(handler) {
  bus.$off('portal-login-open', handler)
}

export function emitLoginSuccess() {
  bus.$emit('portal-login-success')
}

export function onLoginSuccess(handler) {
  bus.$on('portal-login-success', handler)
}

export function offLoginSuccess(handler) {
  bus.$off('portal-login-success', handler)
}
